import { useEffect, useMemo } from 'react';
import { UseInfiniteQueryResult } from 'react-query';

export default function usePrefetchPages<
  TData,
  TQuery extends UseInfiniteQueryResult,
  TPage = TQuery extends UseInfiniteQueryResult<infer R> ? R : unknown
>(query: TQuery, flatMap?: (data: TPage) => TData[], max?: number) {
  const { hasNextPage, fetchNextPage, data, isFetching } = query;
  const pageCount = data?.pages?.length ?? 0;
  const maxPages = max ?? Infinity;

  useEffect(() => {
    let cancelled = false;
    if (!cancelled && hasNextPage && pageCount < maxPages && !isFetching) {
      fetchNextPage();
    }

    return () => {
      cancelled = true;
    };
  }, [hasNextPage, pageCount, maxPages, isFetching, fetchNextPage]);

  return useMemo(() => {
    if (flatMap && data?.pages) {
      return (data.pages as TPage[]).flatMap(flatMap);
    }
    return [];
  }, [data?.pages, flatMap]);
}
